import React from "react";
import { Link } from "react-router-dom";
import styles from "./Card.module.less";

export interface Props {
    image?: string;
    preHeading?: string;
    heading: string;
    linkTo: string;
    backgroundColor: "blueDark" | "blueMid" | "blueLight";
}

function Card(props: Props) {
    const backgroundClass = styles[`Card--${props.backgroundColor}`];

    return (
        <Link className={`${styles.Card} ${backgroundClass}`} to={props.linkTo}>
            <img className={styles["Card-img"]} src={props.image} alt={`Symbol for ${props.heading}`} />
            <span className={styles["Card-preHeading"]}>{props.preHeading}</span>
            <h3 className={styles["Card-heading"]}>{props.heading}</h3>
            <span className={styles["Card-hint"]}>Read more</span>
        </Link>
    );
}

export default Card;
